import React, { Component } from "react";
import {
  Card,
  CardHeader,
  Input,
  CardBody,
  Row,
  Col,
  Table,
  FormGroup,
} from "reactstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import TableScrollbar from "react-table-scrollbar";

import DefaultImg from "../../assets/images/product/Default_img.jpg";
import {
  getAuditMRRowData,
  AuditPopRight,
} from "../../store/Audit_Report/actions";

class IGPCardView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      maximize: true,
    };
  }
  maximizetogle() {
    this.setState((prevState) => ({
      maximize: !prevState.maximize,
    }));
  }
  callNextCard(id) {
    if (this.props.AuditData.length - 1 === this.props.index) {
      this.props.getAuditMRRowData({
        ScreenID: id,
      });
      this.setState((prevState) => ({
        maximize: !prevState.maximize,
      }));
    }
  }

  render() {
    var obj = {};
    obj = this.props.obj;
    return (
      <div className={this.state.maximize ? "maximize" : "minimize"}>
        <>
          <Row className="plaseholder">
            <Col>
              <Card className="mb-0 mt-0">
                <CardHeader className="bg-transparent border-bottom ">
                  <h5 className="card-title-18 pt-2 d-inline-block">
                    In Gate Pass ({this.props.obj.data.code})
                  </h5>
                </CardHeader>
                <CardBody className="pt-1">
                  <Row>
                    <Col md={6}>
                      <div>
                        <ul className="list-style-two p-0 ml-4  ">
                          <li className="clearfix">
                            <span className="ttl">Vehicle No:</span>
                            <span className="dtl">
                              {this.props.obj.data.vehicleno}
                            </span>
                          </li>
                          <li className="clearfix">
                            <span className="ttl">Person Name:</span>
                            <span className="dtl">
                              {this.props.obj.data.personname}
                            </span>
                          </li>
                        </ul>
                      </div>
                    </Col>
                    {/* <Col md={6}>
                          <div>
                            <ul className="list-style-two p-0 ml-4  ">
                              <li className="clearfix">
                                <span className="ttl">Delivery Date:</span>
                                <span className="dtl">
                                  {this.props.obj.data.createdon}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </Col> */}
                  </Row>
                  <Row>
                    <Col md={12} className="m-1">
                      <Card className="pt-1">
                        <CardBody className="p-0">
                          <div className="table-responsive m-1">
                            <TableScrollbar height="400px">
                              <Table className="mb-0 p-1 table-centered">
                                <thead className="bg-light text-center">
                                  <tr>
                                    <th className="">S.No</th>
                                    <th className="">PO Code</th>
                                    <th className="">PO Bill Image</th>
                                    <th className="">Vendor Code</th>
                                    <th className="">Vendor</th>
                                    <th className="">Items Count</th>
                                    <th className="">Remarks</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.props.obj.data.grn2pos.length !== 0 ? (
                                    <>
                                      {this.props.obj.data.grn2pos?.map(
                                        (item, key) => (
                                          <>
                                            <tr key={key}>
                                              <td className="nowrap text-center">
                                                {key + 1}
                                              </td>
                                              <td className="nowrap text-center">
                                                {item.purchaseorder_code}
                                              </td>
                                              <td className="nowrap text-center">
                                                <div className="product-detail text-center">
                                                  <img
                                                    onClick={() =>
                                                      window.open(
                                                        item?.bill_image
                                                          ?.file == null
                                                          ? DefaultImg
                                                          : item?.bill_image
                                                              ?.file,
                                                        "PO Bill Image",
                                                        "width=600,height=400"
                                                      )
                                                    }
                                                    src={
                                                      item?.bill_image?.file ==
                                                      null
                                                        ? DefaultImg
                                                        : item?.bill_image?.file
                                                    }
                                                    alt="PO_Bill_Image"
                                                    title="PO Bill Image"
                                                    className="product-img  img-fluid mx-auto tab-img rounded"
                                                    style={{
                                                      height: "100px",
                                                      width: "150px",
                                                    }}
                                                  />
                                                </div>
                                              </td>
                                              <td className="nowrap text-center">
                                                {item.vendor.name}
                                              </td>
                                              <td className="nowrap text-center">
                                                {item.vendor.code}
                                              </td>
                                              <td className="nowrap text-center">
                                                {item.items_count}
                                              </td>
                                              <td className="nowrap text-center">
                                                {item.description}
                                              </td>
                                            </tr>
                                          </>
                                        )
                                      )}
                                    </>
                                  ) : (
                                    <tr>
                                      <td colSpan={9} className="text-center">
                                        <div>
                                          <span className="font-size-18 text-danger">
                                            Data not available
                                          </span>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </Table>
                            </TableScrollbar>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col md={12} className="m-1">
                      <Card className="pt-1">
                        <CardBody className="p-0">
                          <div className="table-responsive m-1">
                            <TableScrollbar height="400px">
                              <Table className="mb-0 p-1 table-centered">
                                <thead className="bg-light text-center">
                                  <tr>
                                    <th className="">S.No</th>
                                    <th className="">IGP ItemCode</th>
                                    <th className="">PO Code</th>
                                    <th className="">PO Item Code</th>
                                    <th className="">Item Image</th>
                                    <th className="">Items Name</th>
                                    <th className="">Received Quantity</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.props.obj.data.grn2items.length !==
                                  0 ? (
                                    <>
                                      {this.props.obj.data.grn2items?.map(
                                        (item, key) => (
                                          <>
                                            <tr key={key}>
                                              <td className="nowrap text-center">
                                                {key + 1}
                                              </td>
                                              <td className="nowrap text-center">
                                                {item.code}
                                              </td>
                                              <td className="nowrap text-center">
                                                {item.purchaseorder_code}
                                              </td>
                                              <td className="nowrap text-center">
                                                {item.poitem_code}
                                              </td>
                                              <td className="nowrap text-center">
                                                <div className="product-detail text-center">
                                                  <img
                                                    src={
                                                      item?.product?.image ==
                                                      null
                                                        ? DefaultImg
                                                        : item?.product?.image
                                                    }
                                                    alt="product-img"
                                                    title="product-img"
                                                    className="product-img  img-fluid mx-auto tab-img rounded"
                                                    style={{
                                                      height: "75px",
                                                      width: "100px",
                                                    }}
                                                  />
                                                </div>
                                              </td>
                                              <td className="nowrap ">
                                                <h5 className="font-size-14 ">
                                                  {" "}
                                                  {item.product.name}
                                                </h5>
                                                {/* <p className="mb-0">
                                                      Make :{" "}
                                                      <span className="font-weight-medium">
                                                        {item.make}
                                                      </span>
                                                    </p> */}
                                                {/* <p className="mb-0">
                                                    Description :{" "}
                                                    <span className="font-weight-medium">
                                                      {item.description}
                                                    </span>
                                                  </p> */}
                                              </td>
                                              <td className="nowrap text-center">
                                                {item.qty} {item.unit.name}
                                              </td>
                                            </tr>
                                          </>
                                        )
                                      )}
                                    </>
                                  ) : (
                                    <tr>
                                      <td colSpan={9} className="text-center">
                                        <div>
                                          <span className="font-size-18 text-danger">
                                            Data not available
                                          </span>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </Table>
                            </TableScrollbar>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Card className="p-0 ">
                        <CardHeader className="bg-transparent border-bottom p-1">
                          <i className="mdi mdi-alert-circle-outline ml-2 mr-2 font-size-20"></i>

                          <h5 className="card-title-15 d-inline-block">
                            Other Details
                          </h5>
                        </CardHeader>
                        <CardBody className="p-2 ">
                          <div>
                            <FormGroup className="mb-0">
                              <Input
                                type="textarea"
                                className="form-control"
                                placeholder="Enter Details"
                                // maxLength="225"
                                rows="7"
                                disabled={true}
                                value={this.props.obj.data.description}
                              />
                            </FormGroup>{" "}
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col md={6}>
                      <Card className="p-0 ">
                        <CardHeader className="bg-transparent border-bottom p-1">
                          <Row>
                            <Col md={6}>
                              <h5 className="card-title-15 d-inline-block">
                                Vehicle Image
                              </h5>
                            </Col>
                            <Col md={6}>
                              <h5 className="card-title-15 d-inline-block">
                                Person Image
                              </h5>
                            </Col>
                          </Row>
                        </CardHeader>
                        <CardBody className="p-2 ">
                          <Row>
                            <Col md={6}>
                              <div className="product-detail text-center">
                                <img
                                  onClick={() =>
                                    window.open(
                                      this.props.obj.data.vehicle_image?.file ==
                                        null
                                        ? DefaultImg
                                        : this.props.obj.data.vehicle_image
                                            ?.file,
                                      "vehicle Image",
                                      "width=600,height=400"
                                    )
                                  }
                                  src={
                                    this.props.obj.data.vehicle_image?.file ==
                                    null
                                      ? DefaultImg
                                      : this.props.obj.data.vehicle_image?.file
                                  }
                                  alt="vehicle_Image"
                                  title="vehicle Image"
                                  className="product-img  img-fluid mx-auto tab-img rounded"
                                  style={{
                                    height: "180px",
                                    width: "350px",
                                  }}
                                />
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="product-detail text-center">
                                <img
                                  onClick={() =>
                                    window.open(
                                      this.props.obj.data.user_image?.file ==
                                        null
                                        ? DefaultImg
                                        : this.props.obj.data.user_image?.file,
                                      "Person Image",
                                      "width=600,height=400"
                                    )
                                  }
                                  src={
                                    this.props.obj.data.user_image?.file == null
                                      ? DefaultImg
                                      : this.props.obj.data.user_image?.file
                                  }
                                  alt="Person_Image"
                                  title="Person Image"
                                  className="product-img  img-fluid mx-auto tab-img rounded"
                                  style={{
                                    height: "180px",
                                    width: "350px",
                                  }}
                                />
                              </div>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Link
            to="#"
            className="strip"
            onClick={() => {
              this.maximizetogle();
              this.props.AuditPopRight(this.props.index);
            }}
          >
            <div className="MaximizeCard-item mb-2 ">
              <div className="MaximizeCard-title-box d-inline-block">
                <span className="mt-4">
                  Purchase Indent Request ({obj.data.code})
                </span>
              </div>
            </div>
          </Link>
        </>
      </div>
    );
  }
}

const mapStatetoProps = (state) => {
  const { AuditData } = state.AuditReport;
  return { AuditData };
};

export default connect(mapStatetoProps, {
  getAuditMRRowData,
  AuditPopRight,
})(IGPCardView);
